<template>
  <div id="app">
    <Preloader></Preloader>
    <div class="container-fluid">
      <Sidebar v-if="showNavbar"></Sidebar>
      <Menu v-if="showNavbar"></Menu>
    </div>
    <router-view></router-view>
    <DreamCar v-if="showDreamCar"></DreamCar>
    <Footer></Footer>
  </div>
</template>
<script>
import Preloader from '@/components/Preloader'
import Sidebar from '@/components/Sidebar'
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import DreamCar from '@/components/DreamCar'
export default {
  name: 'App',
  data () {
    return {
      showDreamCar: false,
      showNavbar: true
    }
  },
  components: {
    Preloader,
    Sidebar,
    Menu,
    Footer,
    DreamCar
  },
  created () {
    if (this.$route.name === 'AutosNuevosChevrolet' ||
      this.$route.name === 'AutosNuevosCadillac' ||
      this.$route.name === 'AutosSeminuevosChevrolet' ||
      this.$route.name === 'AutosSeminuevosCadillac' ||
      this.$route.name === 'Description' ||
      this.$route.name === 'ProcesoFinanciamiento'
    ) {
      this.showDreamCar = true
    }
    if (this.$route.name === 'SolicitudCredito') {
      this.showNavbar = false
    }
  }
}
</script>
